import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    height: '100%',
    minHeight: 0,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    // Mobile Popup (< md) has a real height, so flex-grow fills the dialog.
    flex: 1,
    minHeight: 300,
    padding: 20,
    background: theme.palette.custom.background.light,
    border: `1px solid ${theme.palette.custom.border.primary}`,
    borderRadius: 16,
    overflowY: 'auto',
    textAlign: 'left',
    maskImage:
      'linear-gradient(to bottom, black 0, black calc(100% - 24px), transparent 100%)',
    WebkitMaskImage:
      'linear-gradient(to bottom, black 0, black calc(100% - 24px), transparent 100%)',
    // Desktop ModalBox (>= md) has no height bound, so cap the body and let it
    // scroll instead of growing the absolutely-centered modal past the viewport.
    [theme.breakpoints.up('md')]: {
      maxHeight: 'min(440px, 60vh)',
    },
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  // Lock 44px height so the Loader's intrinsic size doesn't grow the button.
  actionButton: {
    '&.MuiButton-root': {
      height: 44,
      minHeight: 44,
    },
  },
}));

export default useStyles;
